import { render, staticRenderFns } from "./IubendaPrivacyPolicyModal.vue?vue&type=template&id=ed3a7b74&scoped=true&"
import script from "./IubendaPrivacyPolicyModal.vue?vue&type=script&lang=js&"
export * from "./IubendaPrivacyPolicyModal.vue?vue&type=script&lang=js&"
import style0 from "./IubendaPrivacyPolicyModal.vue?vue&type=style&index=0&id=ed3a7b74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3a7b74",
  null
  
)

export default component.exports